export default "__VITE_ASSET__0a572f6f__"